// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"47e5d8cb","203":"9ef7108c","284":"c4cf9765","294":"e86fa4c4","351":"d2e07336","571":"854948e1","838":"7e40cc6e","985":"e6487861"}[chunkId] + ".chunk.js";
};